// Shared paged-list fetch logic, extracted to remove duplicated code
// (SonarQube "Duplicated Lines") across the *Management / list views WITHOUT
// changing behavior.
//
// The dominant clone across these views is the paged-table fetch body: build the
// standard { page, perPage, ...params } request, call the list API, and on
// status==0 map total/data into the target array (isFirst-gated total) else zero
// the three counters. That body is byte-identical apart from three variables:
//   1) the call function        2) the extra search params        3) the target array name
//
// A consuming view keeps its own template, headers, data, watch and Search, and
// replaces ONLY its fetch body with a one-line delegate, e.g.:
//   Get() {
//     this.GetList(
//       (temp, ok, err) => call.GetTableGPTModelNode(temp, ok, err),
//       { nodeName: this.searchNodeName },
//       "menus"
//     );
//   }
//
// IMPORTANT: pass `callFn` as an arrow that invokes the API method on its own
// object (call.X / this.$call.X). The API methods rely on `this` being the call
// object (they call this.apiPostAuth / this._handle...), so a bare method
// reference would lose that binding.
//
// This is behavior-preserving by construction:
//  - GetList reproduces the exact request/response/reset semantics the views shared.
//  - Busy spinners are toggled only for the flags a view actually declares
//    (`dialog` and/or `loadingTable`), so each view keeps the spinner it already used.
//  - It exposes only a method (no data/watch), so there is no data-merge or
//    duplicate-watcher interaction with the consuming component.
export default {
  methods: {
    GetList(callFn, params, targetKey) {
      if (this.dialog !== undefined) this.dialog = true;
      if (this.loadingTable !== undefined) this.loadingTable = true;
      const { page, itemsPerPage } = this.options;
      let temp = {
        page: this.isSearch ? 1 : page,
        perPage: itemsPerPage == -1 ? this.totalTable : itemsPerPage,
        ...params,
      };
      callFn(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            this.searchTotalTable = dataResponse.data.total;
            this[targetKey] = dataResponse.data.data;
            this.totalTable = this.isFirst
              ? dataResponse.data.total
              : this.totalTable;
          } else {
            this[targetKey] = [];
            this.searchTotalTable = 0;
            this.totalTable = 0;
          }
          if (this.dialog !== undefined) this.dialog = false;
          if (this.loadingTable !== undefined) this.loadingTable = false;
          this.isSearch = false;
          this.isFirst = false;
        },
        (errorResource) => {
          if (this.dialog !== undefined) this.dialog = false;
          if (this.loadingTable !== undefined) this.loadingTable = false;
          this.isSearch = false;
          console.error(errorResource);
        }
      );
    },
  },
};
